import React, { useMemo } from "react";
import GenericTable from "./GenericTable";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { IconButton, Tooltip, Box, Chip, Switch, Stack, Typography } from "@mui/material";

const tipoLabel = (t) => {
  const n = Number(t);
  if (n === 1) return "Correios";
  if (n === 2) return "Vuxx";
  if (n === 3) return "Retirada";
  if (n === 4) return "Gestão de Envios";
  return "Padrão";
};

const DeliveryMethodTable = ({
  deliveryMethods = [],
  rowCount,
  pageSize,
  page,
  onPageChange,
  onPageSizeChange,
  onSearch,
  onEditMethod,
  onDeleteMethod,
  onDeleteSelected,
  onToggleStatus,
  isLoading,
}) => {
  const rows = useMemo(
    () =>
      deliveryMethods.map((m) => ({
        ...m,
        id: m.id,
        nome: m.nome || "N/A",
        tipo_label: tipoLabel(m.tipo),
        status_label: m.status === 1 ? "Ativo" : "Inativo",
        days: m.days || "-",
      })),
    [deliveryMethods]
  );

  const columns = [
    {
      field: "nome",
      headerName: "Forma",
      width: 360,
      renderCell: (p) => (
        <Stack spacing={0.3}>
          <Typography fontWeight={600} noWrap>
            {p.row.nome}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {p.row.tipo_label}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "days",
      headerName: "Prazo",
      width: 120,
      renderCell: (p) =>
        p.value && p.value !== "-" ? (
          <Chip size="small" label={p.value} />
        ) : (
          <Typography variant="body2">-</Typography>
        ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Switch
            size="small"
            checked={Number(params.row.status) === 1}
            onChange={() => onToggleStatus?.(params.row)}
          />
          <Chip
            size="small"
            label={params.row.status_label}
            color={Number(params.row.status) === 1 ? "success" : "default"}
            variant="outlined"
          />
        </Stack>
      ),
    },
    {
      field: "actions",
      headerName: "Ações",
      width: 140,
      renderCell: (params) => (
        <Box display="flex" gap={1}>
          <Tooltip title="Editar">
            <IconButton size="small" onClick={() => onEditMethod?.(params.row)}>
              <EditRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton size="small" onClick={() => onDeleteMethod?.(params.row.id)}>
              <DeleteOutlineRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <GenericTable
      rows={rows}
      columns={columns}
      rowCount={rowCount}
      pageSize={pageSize}
      page={page}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSearch={onSearch}
      isLoading={isLoading}
      onExportPDFTitle="Formas de Entrega Selecionadas"
      exportFileName="formas_entrega"
      onDeleteSelected={onDeleteSelected}
      searchPlaceholder="Buscar por nome…"
      pageSizeOptions={[10, 25, 50, 100]}
      dense
    />
  );
};

export default DeliveryMethodTable;
